import { Pipe, PipeTransform } from '@angular/core';
import { DateUtils } from '../../../utils/date-utils';

@Pipe({
  name: 'dateIsInTheFuture',
  standalone: true
})
export class DateIsInTheFuturePipe implements PipeTransform {
  transform(date: Date | string | number): boolean {
    return DateUtils.isInTheFuture(date);
  }
}
